import React, { PureComponent } from 'react';
// utils
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import {
  setFavoriteVideo,
  deleteFavoriteVideo
} from '../../../redux/reducers/module';
// components
import ReactPlayer from 'react-player';
import StepTitle from './StepTitle';
import Icon from '../../../components/Icon/Icon';
// styles
import styles from './VideoStep.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

class VideoStep extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFavorite: props.data.content.is_favorite,
      isPending: false
    };
  }

  setFavorite = () => {
    const {
      setFavoriteVideo,
      data: {
        content: { id }
      }
    } = this.props;
    this.setState({ isFavorite: true });
    setFavoriteVideo(id).then(() => {
      this.setState({
        isPending: false
      });
    });
  };

  delFavorite = () => {
    const {
      deleteFavoriteVideo,
      data: {
        content: { id }
      }
    } = this.props;
    this.setState({ isFavorite: false });
    deleteFavoriteVideo(id).then(() => {
      this.setState({
        isPending: false
      });
    });
  };

  handleClick = () => {
    const { isFavorite, isPending } = this.state;
    if (!isPending) {
      this.setState({ isPending: true });
      isFavorite ? this.delFavorite() : this.setFavorite();
    }
  };

  render() {
    const {
      module,
      data: { title, description, content }
    } = this.props;
    const { isFavorite } = this.state;
    const isZero = module === 0;

    return (
      <div className={cn('container')}>
        <div className={cn('header')}>
          <StepTitle title={title} description={description} />
          {!isZero && (
            <Icon
              className={cn('favorite', { active: isFavorite })}
              onClick={this.handleClick}
              type="star"
            />
          )}
        </div>
        <div className={cn('wrapper')}>
          <ReactPlayer controls url={content.link} width="100%" height="0" />
        </div>
        <p>{content.description}</p>
      </div>
    );
  }
}

VideoStep.propTypes = {
  data: T.shape({
    title: T.string,
    content: T.shape({
      id: T.oneOfType([T.string, T.number]).isRequired,
      link: T.string.isRequired,
      description: T.string
    })
  })
};

export default connect(
  state => ({
    module: state.auth.user.progress.module
  }),
  { setFavoriteVideo, deleteFavoriteVideo }
)(VideoStep);



// WEBPACK FOOTER //
// ./src/containers/Module/components/VideoStep.jsx